






























import {Vue, Component, Prop} from 'vue-property-decorator'
import {
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BButton, BCol, BRow, BCard, BInputGroup, BCardTitle
} from "bootstrap-vue";
import {VueGoodTable} from 'vue-good-table'
import {NotifyInfo, NotifySuccess} from "@/helpers/Toast";

@Component({
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BRow,
    BCol,
    BCard,
    BCardTitle
  }
})
export default class IdibuAccounts extends Vue {
  columns = [
    {
      label: 'Account Id',
      field: 'acountId',
    },
    {
      label: 'Account Name',
      field: 'acountName',
    },
  ]

  rows: MaintenanceAPI.IdibuAccounts.Item[] = [];

  async created() {
    await this.getItems();
  }

  async getItems() {
    this.rows = await this.$api.maintenance.idibuaccounts.GetList();
  }

  async goTo(params) {
    await this.$router.push({
      name: "maintenance-idibuaccount",
      params: {
        identifier: params.row.accountId
      }
    })
  }

  async create() {
    await this.$router.push({
      name: "maintenance-idibuaccount",
          params: {
        identifier: "create"
      }
    })
  }
}
